export { getSelectedOptions } from './getSelectedOptions';
export { getRange } from './getRange';
